import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

@Injectable()
export class TimingInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const start = performance.now();

    return next.handle(request).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            const elapsedMs = Math.round(performance.now() - start);
            const bytes = Number(event.headers.get('content-length')) || new Blob([JSON.stringify(event.body ?? '')]).size;
            console.log(`[HTTP] ${request.method} ${request.urlWithParams} - ${elapsedMs}ms - status ${event.status} - ${bytes} bytes`);
          }
        },
        error: (err) => {
          const elapsedMs = Math.round(performance.now() - start);
          console.log(`[HTTP] ${request.method} ${request.urlWithParams} - ${elapsedMs}ms - ERROR`, err);
        }
      })
    );
  }
}
